import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { initTheme } from '@/stores/theme'
import { initLanguage } from '@/i18n'

// Both applied before the first render, so the app never flashes the wrong theme or, worse, lays
// the page out left-to-right for a moment before flipping it.
initTheme()
initLanguage()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
